import React from 'react';



export const VoiceRemote = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_remote_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<g>
<path d="M14,3.5A1.51,1.51,0,0,1,15.5,5V19A1.51,1.51,0,0,1,14,20.5H10A1.5,1.5,0,0,1,8.5,19V5A1.5,1.5,0,0,1,10,3.5h4M14,2H10A3,3,0,0,0,7,5V19a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3ZM12,8.19,13.31,9.5,12,10.81,10.69,9.5,12,8.19M12,7a.51.51,0,0,0-.38.16l-2,2a.54.54,0,0,0,0,.76l2,2a.53.53,0,0,0,.76,0l2-2a.54.54,0,0,0,0-.76l-2-2A.51.51,0,0,0,12,7Zm1-1h1a.5.5,0,0,0,.5-.5h0A.5.5,0,0,0,14,5H13a.5.5,0,0,0-.5.5h0A.5.5,0,0,0,13,6ZM10,6h1a.5.5,0,0,0,.5-.5h0A.5.5,0,0,0,11,5H10a.5.5,0,0,0-.5.5h0A.5.5,0,0,0,10,6Zm3,8h1a.5.5,0,0,0,.5-.5h0A.5.5,0,0,0,14,13H13a.5.5,0,0,0-.5.5h0A.5.5,0,0,0,13,14Zm-3,0h1a.5.5,0,0,0,.5-.5h0A.5.5,0,0,0,11,13H10a.5.5,0,0,0-.5.5h0A.5.5,0,0,0,10,14Z"/>

</g>
</g>
</svg>
);
